import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  LOG_GET_LIST,
  LOG_GET_LIST_SUCCESS,
  LOG_GET_LIST_ERROR,
  LOG_IMPORT_GET_LIST_SUCCESS,
  LOG_IMPORT_GET_LIST
} from "./actions";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    importType: '',
    orderBy: "id",
    sortedBy: "asc",
    message: null,
    page: INIT_PAGE_STATE,
    section: "SCHEDULER",
  },
  list_import: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    orderBy: "id",
    sortedBy: "asc",
    message: null,
    page: INIT_PAGE_STATE,
  },
};

const logReducer = (state = INIT_STATE, action) => {
  switch (action.type) {    
    case LOG_GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          filter: action.payload.filter,
          importType: action.payload.importType,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
          title: action.payload.title,
          scheduleJobId: action.payload.scheduleJobId,
          section: action.payload.section,
        },
      };

    case LOG_GET_LIST_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              id: Number(t.id),
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItem: action.payload.meta.pagination.total_item,
            totalPage: action.payload.meta.pagination.total_page,
            itemCount: action.payload.meta.pagination.item_count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    case LOG_GET_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    case LOG_IMPORT_GET_LIST:
      return {
        ...state,
        list_import: {
          ...state.list_import,
          loading: true,
          filter: action.payload.filter,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
        },
      };

    case LOG_IMPORT_GET_LIST_SUCCESS: {
      return {
        ...state,
        list_import: {
          ...state.list_import,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              id: Number(t.id),
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItem: action.payload.meta.pagination.total_item,
            totalPage: action.payload.meta.pagination.total_page,
            itemCount: action.payload.meta.pagination.item_count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    default:
      return state;
  }
};

export default logReducer;
